import React from "react";
import { Route, Routes } from "react-router-dom";
import { useAuthState } from "./hooks/providers/AuthProvider";
import { LazyLogin, LazyRegister } from "./shared/LazyComponents";
import AuthenticatedApp from "./AuthenticatedApp";

const AppContent: React.FC = () => {
  const authState = useAuthState();
  
  // Use the isAuthenticated field from the auth state
  const isAuthenticated = authState?.isAuthenticated ?? false;

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<LazyLogin />} />
        <Route path="/login" element={<LazyLogin />} />
        <Route path="/register" element={<LazyRegister />} />
        <Route path="*" element={<LazyLogin />} />
      </Routes>
    );
  }

  return <AuthenticatedApp />;
};

export default AppContent;
